module.exports = __webpack_public_path__ + "static/media/logo_beclean_weiss.6f436f49.svg";